// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"3d90e7e1","635":"06834a8b"}[chunkId] + ".chunk.js";
};